import styled from "styled-components";
import { Row } from "antd";
export const Container = styled(Row)`
border: 1px solid #E6E7E7;
  border-radius: 8px;
  padding: 24px;
  margin-right: 24px;
  margin-top: 24px;
`